import React from "react";
import { AiOutlineClose } from "react-icons/ai"; 

const Modal = ({ isOpen, onClose, title, children , childrenClass,Classes }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ">
      <div className={` ${Classes} bg-white rounded-lg shadow-lg relative overflow-auto `}  >
        <AiOutlineClose
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 cursor-pointer hover:text-gray-800"
          size={18}
        />

        <h2 className="text-xl font-bold my-4 text-center">{title}</h2>

        <div className={childrenClass} >{children}</div>
      </div>
    </div>
  );
};

export default Modal;
